const sortable = (a, b) => {
  return String(a.sortValue).localeCompare(String(b.sortValue), undefined, {
    numeric: true,
    sensitivity: 'base'
  });
};

export default sortable;
